let currentStepName: string | null = null;

export const setCurrentStepName = (stepName: string | null): void => {
  currentStepName = stepName;
};

export const getCurrentStepName = (): string | null => currentStepName;
